<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1"
	stroke-linecap="round"
	stroke-linejoin="round"
	class="feather feather-closed-caption"
	><rect x="2" y="6" width="20" height="12" rx="2" ry="2" /><text
		x="12"
		y="15"
		font-family="sans-serif"
		font-size="8"
		font-weight="bold"
		fill="currentColor"
		stroke="none"
		text-anchor="middle">CC</text
	></svg
>
